module.exports = __webpack_public_path__ + "public/images/modals/netw-choose-company-mobile.a90cf5e759b45fa5c9c580c576aacf2c.png";